/** @module Specification/PartMaterialColor/PMCColorRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/config",
	"csi/constants",
	"csi/heading/Ref",
	"csi/reflection",
	"csi/store/GroupQueryEngine",
	"csi/xml",
	"Apparel/ProductColorMixin"
], function(declare, _, csi, config, constants, Ref, reflection, GroupQueryEngine, xml, ProductColorMixin) {

	return declare([Ref, ProductColorMixin], {
		COLOR_SPECIFICATION_TYPE: "ColorSpecification",
		FOOD_BOMLINE_ITEM: "FoodBOMLineItem",
		PART_MATERIAL: "PartMaterial",
		PART_MATERIAL_COLOR: "PartMaterialColor",

		bCopy: true,

		dropDownCssClass: "groupedDropDown",

		/**
		 * @override
		 * The custom store key is PartMaterial.Actual, display the PMCColors that belong to the current product
		 */
		getCustomStoreKey: function(ctx, h, bAll) {
			return this._getBOMLineItem(ctx).Actual + "^" + !!this._isOKColorSpecs(ctx);
		},

		/**
		 * @override
		 * Display ColorSpecs for selection only if PartMaterial.OKColorSpecs exists and is True
		 */
		_getStoreAction: function(ctx, h, bAll) {
			return this._isOKColorSpecs(ctx) ? this._getMaterialColorSpecsAction(ctx) : this._getProductColorsAction(ctx);
		},

		/**
		 * @override
		 * Add group to the ColorInPalette result node
		 */
		getStoreOptions: function (ctx, h) {
			if (this._isColorRuleEnforcedOrEnabled(ctx)) {
				return {
					// ProductColorSpecs will be missing from drop-down query, but are still valid
					ignoreInvalid: true,
					treatAsPriority: true,

					customOperation: true,
					queryEngine: GroupQueryEngine,
					requestParameters: {
						[constants.DEP_PATH]: reflection.PATH_PARENT
					},
					_processResultNode: function (/*Node*/node, /*Cache*/cache) {
						const parent = cache.getNode(node.__Parent__);
						const groupName = parent && node.$Type == "ColorInPalette" ? parent.$Name : "";
						return { $: node.$URL, Name: node.$Name, node: node, group: groupName };
					}
				};
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * If Material has colors, but PartMaterial allows to select ColorSpecification nodes, then return action to select ProductColors
		 */
		_getPriorityStoreAction: function(ctx, h) {
			var product = this._getProduct(ctx);
			if (product?.ProductColors.length && this._isOKColorSpecs(ctx)) {
				return this._getProductColorsAction(ctx);
			}

			return this.inherited(arguments);
		},

		/**
		 * Check if PartMaterial.OKColorSpecs exist and is true
		 * @param {Context} ctx
		 */
		_isOKColorSpecs: function(ctx) {
			var pm = this._getBOMLineItem(ctx);
			return !pm.ForStyle && pm.OKColorSpecs;
		},

		/**
		 * Return BomLineItem node, whether node in context is PartMaterialColor or BomLineItem
		 * @param {Context} ctx
		 * @return {Node}
		 */
		_getBOMLineItem: function(ctx) {
			return (ctx.getNodeType() == this.PART_MATERIAL || ctx.getNodeType() == this.FOOD_BOMLINE_ITEM) ? ctx.getNode() : ctx.getNodeParent();
		},

		/**
		 * @override
		 * Return Product node for BomLineItem
		 */
		_getProduct: function(ctx) {
			return ctx.cache.getNode(this._getBOMLineItem(ctx).Actual);
		},

		/**
		 * @override
		 * Depending on OKColorSpecs and Common Color Type, allow or deny drag fill
		 */
		canPaste: function(ctxCopy, ctxPaste, h) {
			var fromPartMaterial = ctxCopy.getNode();
			var color = ctxCopy.cache.get(fromPartMaterial.CommonColor || fromPartMaterial.PMCColor);
			var colorType = color ? color.$Type : null;
			var toPartMaterial = this._getBOMLineItem(ctxPaste);
			if (toPartMaterial.OKColorSpecs && (colorType == this.COLOR_SPECIFICATION_TYPE)) {
				return true;
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Add unavailable CSS if PartMaterial.CommonColorAvailable or PartMaterialColor.ColorAvailable is false
		 */
		_getRenderCSS: function(ctx, h) {
			let css = this.inherited(arguments);
			const node = ctx.getNode();
			if (!node) {
				return css;
			}

			const nodeType = ctx.getNodeType();
			if ((nodeType == this.PART_MATERIAL && !node.CommonColorAvailable) || (nodeType == this.PART_MATERIAL_COLOR && !node.ColorAvailable)) {
				css += " unavailable";
			}
			return css;
		}
	});
});
